import styled from "styled-components";
import { colours } from "../../../../styles/colours.constants";
import { satoshi900 } from "../../../../styles/font.constants";
import { BasePostStyles, BaseTitle, Text } from "../../posts.styles";

type PostStyleProps = {
	$colour: string;
};

export const Post = styled.div<PostStyleProps>`
	${BasePostStyles}
	border-left-width: 6px;
	border-left-color: ${({ $colour }) => $colour};
	border-left-style: solid;
`;

export const Title = styled.div<PostStyleProps>`
	${BaseTitle}
	color: ${({ $colour }) => $colour};
	margin-top: 0;
`;

export const Score = styled.div`
	${satoshi900}
	color: ${colours.black};
	size: 1rem;
	text-transform: uppercase;
`;

export const PlayerRow = styled.div`
	display: flex;
	gap: 0.5rem;
	justify-content: flex-start;
	align-items: center;
`;

export { Text, BaseTitle };
